import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';
import { Checkbox } from 'semantic-ui-react';
import { push } from "connected-react-router";

import PollItem from "./PollItem/PollItem";
import PaginationBlock from "../../ui/PaginationBlock/PaginationBlock";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import {
  changePollsPage,
  changePollsLimit,
  getPollsListAsync,
  switchPollsFilter,
  goToPollCreation,
  restorePollAsync,
} from "../../../redux/actions/pollsList";

const mapStateToProps = state => ({
  ...state.pollsList,
});

const mapDispatchToProps = dispatch => ({
  onChangePage: page => dispatch(changePollsPage(page)),
  onChangeDisplayOption: limit => dispatch(changePollsLimit(limit)),
  onCreatePoll: () => dispatch(goToPollCreation()),
  getPollsList: payload => dispatch(getPollsListAsync(payload)),
  switchFilter: filter => dispatch(switchPollsFilter(filter)),
  onRestorePoll: (status, pollId, pollIndex) => dispatch(restorePollAsync(status, pollId, pollIndex)),
  onClickPollItem: pollId => dispatch(push(`/poll/${pollId}`)),
});

class PollsList extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    polls: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    activePage: PropTypes.number.isRequired,
    filters: PropTypes.object.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onChangeDisplayOption: PropTypes.func.isRequired,
    onCreatePoll: PropTypes.func.isRequired,
    getPollsList: PropTypes.func.isRequired,
    switchFilter: PropTypes.func.isRequired,
    onRestorePoll: PropTypes.func.isRequired,
    onClickPollItem: PropTypes.func.isRequired,
  };

  componentDidMount = () => { 
    const { getPollsList } = this.props;
    const payload = this.setPayload();
    getPollsList(payload);
  }

  //Пагинация и фильтры
  componentDidUpdate = previousProps => {
    const { limit, activePage, filters, getPollsList } = this.props;
    const payload = this.setPayload();

    //Условия перезагрузки
    if (
      (previousProps.activePage !== activePage)
      || (previousProps.limit !== limit)
      || (previousProps.filters.clients !== filters.clients)
      || (previousProps.filters.consultants !== filters.consultants)
      || (previousProps.filters.all !== filters.all)
    ) getPollsList(payload);
  }

  setPayload = () => {
    const { limit, activePage, filters } = this.props;
    //Пагинация:
    //limit - количество пользователей на одну страницу пагинации
    //page - активная страница
    const payload = {
      limit,
      page: activePage,
      type: [],
    };
    //Фильтры
    if (filters.clients) payload.type.push('CLIENTS');
    if (filters.consultants) payload.type.push('CONSULTANTS');
    if (filters.all) payload.type.push('ALL');
    return payload;
  }

  renderPollsList = (poll, i) => {
    const { onRestorePoll, onClickPollItem } = this.props;
    return(
      <PollItem
        key={`${poll.id}_${i}`}
        poll={poll}
        onRestore={() => onRestorePoll('ENABLED', poll.id, i)}
        onClickPoll={(id) => onClickPollItem(id)}
      />
    );
  }

  render() {
    const {
      ready, loading, polls, limit, total, activePage, filters, onChangePage, onChangeDisplayOption, onCreatePoll,
      switchFilter,
    } = this.props;

    //Рассчитаем количество страниц пагинации
    const pagesCount = Math.ceil(total / limit);

    const contentClass = classnames({
      'list-items-content': true,
      'hollow': polls.length === 0,
    });

    return (
      <div className="list-items-wrap">
        <div className="list-items-header">
          <button type="button" className="btn btn-green" onClick={() => onCreatePoll()}>Создать опрос</button>
          <div className="filters-wrap">
            <Checkbox
              label='Для клиентов'
              checked={filters.clients}
              onChange={() => switchFilter('clients')} 
            />
            <Checkbox
              label='Для консультантов'
              checked={filters.consultants}
              onChange={() => switchFilter('consultants')}
            />
            <Checkbox
              label='Для всех'
              checked={filters.all}
              onChange={() => switchFilter('all')}
            />
          </div>
        </div>
        {ready ? (
          <React.Fragment>
            <div className={contentClass}>
              {polls.length !== 0 ? 
                polls.map(this.renderPollsList)
              : (
                <div className="hollow-text">
                  Здесь пока пусто.<br />
                  Создайте первый опрос
                </div>
              )}
            </div>
            {polls.length !== 0 ? (
              <div className="list-items-footer">
                <PaginationBlock
                  activePage={activePage}
                  pagesCount={pagesCount}
                  pagesVisible={7}
                  onChangePage={onChangePage}
                  displayOptions={[15, 30, 60, 120]}
                  selectedDisplayOption={limit}
                  selectDisplayOption={onChangeDisplayOption}
                />
              </div>
            ) : false}
          </React.Fragment>
        ) : false}
        {loading ? (<Spinner />) : false}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(PollsList));
